var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileWithGradientImpersonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_5121)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.714a4.286 4.286 0 1 0 0-8.571 4.286 4.286 0 0 0 0 8.571Z",
    stroke: "url(#paint0_linear_874_5121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68 20.4a8.572 8.572 0 0 1 14.64 0",
    stroke: "url(#paint1_linear_874_5121)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.143c6.154 0 11.143-4.989 11.143-11.143C23.143 5.846 18.153.857 12 .857 5.846.857.857 5.846.857 12c0 6.154 4.989 11.143 11.143 11.143Z",
    stroke: "url(#paint2_linear_874_5121)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_874_5121",
    x1: 9.855,
    y1: 5.381,
    x2: 15.209,
    y2: 8.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_874_5121",
    x1: 8.336,
    y1: 16.402,
    x2: 11.064,
    y2: 21.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_874_5121",
    x1: 6.423,
    y1: 1.476,
    x2: 20.344,
    y2: 8.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_5121"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWithGradientImpersonation);
export default __webpack_public_path__ + "static/media/profileWithGradientImpersonation.62c6d40b903ff2292c3e1818a7c3df04.svg";
export { ForwardRef as ReactComponent };